import { backend } from "@/backend";

export class Token {
    static set(token) {
        localStorage.setItem('token', token);
    }

    static get() {
        return localStorage.getItem('token') || null;
    }

    /**
     * Elimina el token del localStorage
     */
    static clear() {
        localStorage.removeItem('token');
    }

    static async isValid(token) {
        if (!token) {
            return false;
        }

        try {
            await backend.post('auth/token/verify');
        } catch (error) {
            return false;
        }

        return true;
    }
}